/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Вид для формы выбора страны.
   */
  app.ChoiceCountryView = app.View.extend({
    el: '.choice-country',
    defaultNameEn: 'russia',
    defaultNameRu: 'Россия',

    /**
     * @inheritDoc
     */
    run: function () {
      if (!this.model) {
        this.model = app.countryFlag;
      }
      this.template = _.template($('#choice-country-template').text());

      if (app.locale === app.LOCALES.ru) {
        var popupSelector,
          element;
        if (this.$el.data('popup-id')) {
          popupSelector = '#' + this.$el.data('popup-id');
        }
        if (popupSelector) {
          element = $(popupSelector);
        } else {
          element = $('.choice-country-popup').eq(0).clone();
          element.removeAttr('id');
          $('.popups').append(element);
        }
        this.popup = element;
        this.popup_pos = new als.Popup(this.popup, this.$el);

        this.popup_pos.addEventListener(
          als.Popup.EventType.BEFORE_OPEN,
          function () {
            var leftOffset = this.$el.offset().left;
            var topOffset = this.$el.offset().top + this.$el.innerHeight() + 10;
            var $body = $('body');
            if (!app.isDesktop) {
              leftOffset = leftOffset - $body.position().left;
              topOffset = topOffset - $body.position().top;
            }
            if (leftOffset + this.popup.width() > $body.width()) {
              leftOffset -= this.popup.width();
            }
            this.popup.css({
              left: leftOffset,
              top: topOffset
            });
          }.bind(this)
        );
        if (!this.model.get('code')) {
          var countryFlag = app.countryFlags[this.defaultNameEn];
          this.model.set({
            nameEn: this.defaultNameEn,
            nameRu: countryFlag.nameRu,
            code: countryFlag.code,
            countryId: countryFlag.countryId
          });
        }
        this.choiceCountryPopup = new app.ChoiceCountryPopupView({el: this.popup, model: this.model});
        this.listenTo(this.model, 'change', this.choiceCountry);
      } else {
        $('.with-icon_arrowdown-blue').addClass('not_display');
        $('.choice-country').css('cursor', 'default');
        this.model.set({
          nameEn: 'other',
          nameRu: 'Другое',
          code: ' ',
          countryId: -1
        });
      }
      this.choiceCountry();
    },

    /**
     * @inheritDoc
     */
    render: function () {
      this.popup.find('.head-actions').html(this.template({currentModelNameEn: this.nameEn}));
    },
    
    /**
     * Выбирает страну
     */
    choiceCountry: function () {
      this.nameEn = this.model.get('nameEn') || this.defaultNameEn;
      this.nameRu = this.model.get('nameRu') || this.defaultNameRu;
      this.$el.find('.choice-country_active').attr('data-country', this.nameEn);
      this.$el.find('.choice-country_active').attr('class', 'choice-country_active with-icon_' + this.nameEn);
      this.$el.find('.choice-country_active').text(this.nameRu);
      if (app.locale === app.LOCALES.ru) {
        this.render();
        this.popup_pos.close();
      }
    }
  });
})(jQuery);

}.call(window));